import React from "react";
import type { TOrganizer } from "components/organizer/helpers/organizer-types-helper";
import Organizer from "components/organizer";
import Icons from "components/icons";
import { PermissionButton } from "components/permissions";
import { Localize, ModalStandard } from "components/service";
import EmailChannelEditForm from "../email-channel-edit-form";

interface IEmailChannelConnectModalProps {
  organizer: TOrganizer;
  variables: Record<string, any>;
  buttonLabel: React.ReactNode;
  buttonClassName?: string;
}

const EmailChannelConnectModal: React.FC<IEmailChannelConnectModalProps> = ({
  organizer,
  variables,
  buttonLabel,
  buttonClassName = "",
}) => (
  <ModalStandard
    width={500}
    extraClass="modal-form"
    modalButton={
      <PermissionButton
        permission={Organizer.Const.permissions.UPDATE}
        disabledFallback
        type="primary"
        className={`email-channel-connect-button ${buttonClassName}`.trim()}
        icon={<Icons.Connect />}
      >
        <span className="ellipsis">{buttonLabel}</span>
      </PermissionButton>
    }
    modalTitle={
      <strong className="modal-title">
        <span className="text">
          <Localize>EMAIL_CHANNEL.Modal_Title_Connect</Localize>
        </span>
      </strong>
    }
  >
    <EmailChannelEditForm
      organizer={organizer}
      variables={variables}
    />
  </ModalStandard>
);

export default EmailChannelConnectModal;
